import React from 'react';
import { useEffect, useRef } from 'react';

export default function ConfirmModal({ isOpen, onConfirm, onCancel, title, message, confirmText, confirmButtonClass }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        onConfirm(); // Always trigger discard when Enter is pressed in modal
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        onCancel(); // Allow Escape to cancel
      }
    };

    if (isOpen) {
      // Set focus on modal when it opens
      if (modalRef.current) {
        modalRef.current.focus();
      }
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onConfirm, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[200] flex items-center justify-center p-4">
      <div 
        ref={modalRef}
        tabIndex={-1}
        className="bg-white p-4 md:p-6 rounded-lg w-full max-w-[320px] md:max-w-[400px] shadow-xl outline-none"
      >
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-white rounded ${confirmButtonClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
